import PageSeo from "./PageSeo";
import {
    PAGE_META_DEFAULTS,
    resolveMetaText,
} from "../../utils/pageMeta";
export function PageShell({ children, className = "" }) {
    return (
        <div className={`min-w-0 -mx-2 px-1 py-4 md:px-0 md:py-4 ${className}`.trim()}>
            {children}
        </div>
    );
}

export function PageInfoHint({ title }) {
    return (
        <span
            className="inline-flex h-5 w-5 cursor-help items-center justify-center rounded-full border border-slate-300 text-xs font-semibold text-slate-600"
            title={title}
        >
            i
        </span>
    );
}

export default function PageHeader({
    title,
    description,
    metaTitle,
    metaDescription,
    metaKeywords,
    path,
    imagePath,
    imageAlt,
    structuredData,
    noIndex = false,
    visible = true,
    actions,
    children,
    className = "",
}) {
    const pageDescription =
        resolveMetaText(metaDescription) ||
        resolveMetaText(description) ||
        PAGE_META_DEFAULTS.description;
    const keywords = resolveMetaText(metaKeywords);

    return (
        <>
            <PageSeo
                title={resolveMetaText(metaTitle) || resolveMetaText(title)}
                description={pageDescription}
                keywords={keywords}
                path={path}
                imagePath={imagePath}
                imageAlt={imageAlt}
                structuredData={structuredData}
                noIndex={noIndex}
            />

            {visible ? (
                <header className={`mb-6 ${className}`.trim()}>
                    <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
                        <div className="min-w-0">
                            <div className="mb-1 flex flex-wrap items-center gap-2">
                                <h1 className="main-heading mb-0 text-2xl font-bold tracking-tight text-slate-900 md:text-4xl">
                                    {title}
                                </h1>
                                {children}
                            </div>
                            {description ? (
                                <p className="subtext mb-0 text-sm md:text-base">{description}</p>
                            ) : null}
                        </div>
                        {actions ? <div className="shrink-0 self-start">{actions}</div> : null}
                    </div>
                </header>
            ) : null}
        </>
    );
}
